import { render, staticRenderFns } from "./UiDropdownItem.vue?vue&type=template&id=ba9cefcc&"
import script from "./UiDropdownItem.vue?vue&type=script&lang=js&"
export * from "./UiDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/server/itg-custom/staging/front/components/UiIcon.vue').default})
